import { useIntl } from 'react-intl';

export const useUnknownChartSeriesLabel = (): string => {
    const { formatMessage } = useIntl();

    return formatMessage({
        id: 'Objects.UNKNOWN.DEFAULT',
        description: 'Label for unknown',
        defaultMessage: 'Unknown'
    });
};
